module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-pa004.b02dcbca.png";